<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">Detail {{module}}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{name:'dashboards'}">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{name: table_module}">{{module}}</router-link>
              </li>
              <li class="breadcrumb-item active">detail</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card min-h-350">
          <div class="card-body">
            <div class="media align-items-center d-flex">
              <div class="avatar-md mr-3">
                <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-20">
                  <i class="bx bx-store"></i>
                </span>
              </div>
              <div class="media-body overflow-hidden">
                <h5 class="text-truncate font-size-18">
                  {{data.str_name}}
                </h5>
                <p class="text-muted mb-0">
                  {{data.str_address}}
                </p>
              </div>
            </div>

            <h5 class="font-size-15 mt-4">About</h5>

            <div class="table-responsive">
              <table class="table table-nowrap mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Jam Operasi :</th>
                    <td>Setiap Hari - {{data.str_open}} - {{data.str_close}} WIB</td>
                  </tr>
                  <tr>
                    <th scope="row">Location</th>
                    <td>
                      {{data.str_address}}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">E-mail :</th>
                    <td>
                      {{data.str_email}}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Phone :</th>
                    <td>
                      {{data.str_phone}}
                    </td>                    
                  </tr>
                  <tr>
                    <th scope="row">Whatsapp :</th>
                    <td>
                      {{data.str_whatsapp_number}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      show: 10,
      page: 1,
      isLoading: false,
      module: "Troubleshoot",
      table_module: "troubleshoot",
      alias_table: "ts",
      uuid: this.$route.params.uuid,
      data: {},
      dataSearch: {},
      childDataLoaded: false,
      fields_trans: {},
      data_trans: {},
    };
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    fetchDetail() {
      this.isLoading = true;
      this.axios
        .get("/" + this.table_module + "/detail/" + this.uuid)
        .then((response) => {
          this.isLoading = false;
          this.data = response.data.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            this.$toast.error("Data tidak ada");
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    qucikCreateShow(arm) {
      this.visible = arm;
    },
  },
};
</script>